import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router'
import { iif, Observable, of } from 'rxjs'
import { filter, first, map, mergeMap } from 'rxjs/operators'
import { BpmnModelDto } from '../../../../commons/BpmnModel.dto'
import { ApiService } from '../services/api.service'
import { ViewVisibilitiesService } from '../services/view.visibilities.service'

@Injectable({
  providedIn: 'root',
})
export class BpmnModelsResolver implements Resolve<BpmnModelDto[]> {
  constructor(
    private apiService: ApiService,
    private vvs: ViewVisibilitiesService,
  ) {}
  public resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<BpmnModelDto[]> {
    return this.vvs
      .get(route.paramMap.get('orgUuid'))
      .pipe(
        mergeMap((visibilities) =>
          iif(
            () => visibilities.modeler.read.visible,
            this.apiService.listBpmnModels(route.paramMap.get('orgUuid')),
            of([] as BpmnModelDto[]),
          ),
        ),
      )
  }
}
